var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.page_loaded)?_c('app-spinner'):[_c('app-cells',[_c('h1',{staticClass:"title"},[_vm._v(_vm._s(_vm.airline_data.name))])]),_c('app-tabs',{attrs:{"tabs":_vm.tabs}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"airline":_vm.airline_data},on:{"update":_vm.fetchData}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }